import React from 'react'
import styles from '../Proj5Folder/Proj5.module.css'
import urban13p from '../../Images/urban13.jpg'



export default function urban12() {
  return (

    <>
       <section className='my-5 py-3 '>
       <div  className={`container  `}>
        
          <div className="container my-5 py-5 ">
              <div className="row align-items-center">
                <div className="col-md-6">
                    <h3 className={`${styles.color} my-3`}> Green Highland ​</h3>
                    <p> Project description: planning  </p>
                    <p>Type of contract: Design  </p>
                    <p>Type of works : Master Planning Detailed Planning and Presentaion </p>
                </div>
                <div className="col-md-6">
                    <img src={urban13p} alt="achegy" className='img-fluid'/>
                </div>   
              </div>

          </div>
   
       </div>


    </section>

    
    </>
   
  )
}
